import React from 'react';
import PropTypes from 'prop-types';
import useIsNI2 from 'products/nomad_insurance/hooks/useIsNI2';
import { useHistory } from 'react-router';
import useTMLPowerformUrl from 'products/nomad_insurance/hooks/useTMPowerformUrl';
import { CancelButton, Container, StartYourClaimButton } from './styled';

const ActionButtons = ({ onClose, selectedContract }) => {
  const history = useHistory();

  const { isSWProvider } = useIsNI2(selectedContract);
  const { tmPowerformUrl } = useTMLPowerformUrl(selectedContract);

  const navigateToClaims = () => {
    if (isSWProvider) {
      history.push('/nomad-insurance/claim');
      return;
    }
    window.open(tmPowerformUrl, '_blank', 'noopener');
  };

  return (
    <Container>
      <CancelButton onClick={onClose}>Cancel</CancelButton>
      <StartYourClaimButton onClick={navigateToClaims}>
        Start your claim
      </StartYourClaimButton>
    </Container>
  );
};

ActionButtons.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedContract: PropTypes.object
};

export default ActionButtons;
